// extracted by mini-css-extract-plugin
export default {"Footer":"styles_Footer__i7tXj","Footer__Wrapper":"styles_Footer__Wrapper__6qOqy","Footer__Links":"styles_Footer__Links__1TYLu","Footer__Logo":"styles_Footer__Logo__XbvpF"};